/*
 * @Descripttion:
 * @Author: Yi Yunwan
 * @Date: 2020-09-04 10:59:42
 * @LastEditors: chenzhi
 * @LastEditTime: 2023-08-24 11:28:07
 */
import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  { path: '/', redirect: '/spread' },
  {
    path: '/index',
    name: 'index',
    component: () => import('@/views/index/index.vue'),
    meta: {
      title: '实名认证'
    }
  },
  {
    path: '/certification',
    name: 'certification',
    component: () => import('@/views/index/certification.vue'),
    meta: {
      title: '实名认证'
    }
  },
  {
    path: '/videosharing',
    name: 'VideoSharing',
    component: () => import('@/views/share/VideoSharing.vue'),
    meta: {
      title: '来电分享'
    }
  },
  {
    path: '/ringsharing',
    name: 'RingSharing',
    component: () => import('@/views/share/RingSharing.vue'),
    meta: {
      title: '铃声分享'
    }
  },
  {
    path: '/wallpapersharing',
    name: 'WallpaperSharing',
    component: () => import('@/views/share/WallpaperSharing.vue'),
    meta: {
      title: '壁纸分享'
    }
  },
  {
    path: '/smspush',
    name: 'SmsPush',
    component: () => import('@/views/note/SmsPush.vue')
  },
  {
    path: '/download',
    name: 'Download',
    component: () => import('@/views/download/Download.vue')
  },
  {
    path: '/downloadapp',
    name: 'Downloadapp',
    component: () => import('@/views/download/Downloadapp.vue')
  },
  {
    path: '/download-app',
    name: 'Download-app',
    component: () => import('@/views/download/Download-app.vue')
  },
  {
    path: '/spread',
    name: 'Spread',
    component: () => import('@/views/extension/Spread.vue')
  },
  {
    path: '/download-allo',
    name: 'DownloadAllo',
    component: () => import('@/views/download-allo/DownloadAllo.vue'),
    meta: {
      title: 'Allo升级'
    }
  },
  {
    path: '/feedback',
    name: 'Feedback',
    component: () => import('@/views/feedback/Feedback.vue'),
    meta: {
      title: '帮助与反馈'
    }
  },
  {
    path: '/problem',
    name: 'problem',
    component: () => import('@/views/feedback/Problem.vue'),
    meta: {
      title: '问题反馈'
    }
  },
  {
    path: '/songlist-share',
    name: 'songlist-share',
    component: () => import('@/views/share/SonglistShare.vue'),
    meta: {
      title: '歌单分享'
    }
  },
  {
    path: '/dianshi',
    name: 'dianshi',
    component: () => import('@/views/ott/dianshi.vue')
  },
  {
    path: '/ott-qiantie',
    name: 'ott-qiantie',
    component: () => import('@/views/ott/OTTqiantie.vue')
  },
  {
    path: '/ott-zanting',
    name: 'ott-zantinge',
    component: () => import('@/views/ott/OTTzanting.vue')
  },
  {
    path: '/invitegroup',
    name: 'Invitegroup',
    component: () => import('@/views/group/Invitegroup.vue')
  },
  {
    path: '/information',
    name: 'Information',
    component: () => import('@/views/information/Information.vue')
  },
  {
    path: '/message',
    name: 'message',
    component: () => import('@/views/message-landing/Message.vue')
  },
  {
    path: '/instructions',
    name: 'instructions',
    component: () => import('@/views/instructions/Instructions.vue')
  },
  {
    path: '/dynamic',
    name: 'dynamic',
    component: () => import('@/views/dynamic/DynamicIndex.vue'),
    meta: {
      title: '动态详情分享'
    }
  },
  {
    path: '/preview',
    name: 'preview',
    component: () => import('@/views/channel/preview.vue'),
    meta: {
      title: '频道详情预览'
    }
  },
  {
    path: '/channel-details',
    name: 'channel-details',
    component: () => import('@/views/channel/ChannelDetails.vue'),
    meta: {
      title: '频道详情'
    }
  },
  {
    path: '/channel-sharing',
    name: 'channel-sharing',
    component: () => import('@/views/channel/ChannelSharing.vue'),
    meta: {
      title: '频道详情分享'
    }
  },
  {
    path: '/exchange',
    name: 'exchange',
    component: () => import('@/views/bean-exchange/exchange.vue'),
    meta: {
      title: '积分'
    }
  },
  {
    path: '/question',
    name: 'problem',
    component: () => import('@/views/bean-exchange/question.vue'),
    meta: {
      title: '积分问题'
    }
  },
  {
    path: '/inventory',
    name: 'inventory',
    component: () => import('@/views/bean-exchange/inventory.vue'),
    meta: {
      title: '积分清单'
    }
  },
  {
    path: '/exchange-confirm',
    name: 'exchange-confirm',
    component: () => import('@/views/bean-exchange/exchange-confirm.vue'),
    meta: {
      title: '兑换确认'
    }
  },
  {
    path: '/real-person',
    name: 'real-person',
    component: () => import('@/views/bean-exchange/real-person.vue'),
    meta: {
      title: '真人认证'
    }
  },
  {
    path: '/diamond',
    name: 'diamond',
    component: () => import('@/views/diamond/diamond.vue'),
    meta: {
      title: '金币'
    }
  },
  {
    path: '/record',
    name: 'record',
    component: () => import('@/views/diamond/record.vue'),
    meta: {
      title: '金币清单'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/aboutus/about.vue'),
    meta: {
      title: '关于我们'
    }
  },
  {
    path: '/collection',
    name: 'collection',
    component: () => import('@/views/collection/collection.vue'),
    meta: {
      title: '个人信息收集清单'
    }
  },
  {
    path: '/tripartite',
    name: 'tripartite',
    component: () => import('@/views/tripartite/tripartite.vue'),
    meta: {
      title: '第三方共享清单'
    }
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import('@/views/agreement/agreement.vue'),
    meta: {
      title: '充值协议'
    }
  },
  {
    path: '/selected',
    name: 'selected',
    component: () => import('@/views/selected/selected.vue'),
    meta: {
      title: '如何成为优质单身？'
    }
  },
  {
    path: '/illustrate',
    name: 'illustrate',
    component: () => import('@/views/illustrate/illustrate.vue'),
    meta: {
      title: '付费说明'
    }
  },
  {
    path: '/security-center',
    name: 'SecurityCenter',
    component: () => import('@/views/security-center/SecurityCenter.vue'),
    meta: {
      title: '安全中心'
    }
  },

  {
    path: '/standard',
    name: 'standard',
    component: () => import('@/views/security-center/standard.vue'),
    meta: {
      title: '平台行为规范'
    }
  },
  {
    path: '/guide',
    name: 'guide',
    component: () => import('@/views/security-center/guide.vue'),
    meta: {
      title: '防骗指南'
    }
  },
  {
    path: '/fraud',
    name: 'fraud',
    component: () => import('@/views/security-center/Fraud.vue'),
    meta: {
      title: '反电信网络诈骗通知'
    }
  },
  {
    path: '/special',
    name: 'special',
    component: () => import('@/views/security-center/special.vue'),
    meta: {
      title: '清朗专项行动'
    }
  },
  {
    path: '/net-operation',
    name: 'net-operation',
    component: () => import('@/views/security-center/NetOperation.vue'),
    meta: {
      title: '净网行动'
    }
  },
  {
    path: '/payment-info',
    name: 'payment-info',
    component: () => import('@/views/Payment-info/paymentInfo.vue'),
    meta: {
      title: '付费说明'
    }
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () =>
      import(
        /* webpackChunkName: "agreement" */ '@/views/agreement/agreement.vue'
      ),
    meta: {
      title: '充值协议'
    }
  },
  {
    path: '/invite',
    name: 'invite',
    component: () => import('@/views/invite/index.vue'),
    meta: {
      title: '邀请好友'
    }
  },
  {
    path: '/share-download',
    name: 'shareDownload',
    component: () => import('@/views/invite/download.vue'),
    meta: {
      title: '下载'
    }
  },
  {
    path: '/chat-rule',
    name: 'chatRule',
    component: () => import('@/views/rules/chatRule.vue'),
    meta: {
      title: '活动规则'
    }
  },
  {
    path: '/invite-rule',
    name: 'inviteRule',
    component: () => import('@/views/rules/inviteRule.vue'),
    meta: {
      title: '活动规则'
    }
  }
]

const router = new VueRouter({
  routes
})

export default router
